export const KEY_MANAGEMENT_START = 'KEY_MANAGEMENT_START';
export const KEY_MANAGEMENT_END = 'KEY_MANAGEMENT_END';
export const KEY_MANAGEMENT_SUCCESS = 'KEY_MANAGEMENT_SUCCESS';
export const KEY_MANAGEMENT_REQUEST_SUCCESS = 'KEY_MANAGEMENT_SUCCESS';

export const KEY_MANAGEMENT_OUTKEYS_SUCCESS = 'KEY_MANAGEMENT_OUTKEYS_SUCCESS';
export const KEY_MANAGEMENT_TEAM_STATUS = 'KEY_MANAGEMENT_TEAM_STATUS';
